<template>
	<div class="login">
		<div class="login__form">
			<h1 class="login__form__title">Login</h1>
			<Alert
				v-if="alert_message"
				class="login__form__alert"
				:message="alert_message"
				:button="alert_button"
				@sendVerification="sendVerification">
			</Alert>
			<form
				v-if="!forgotPasswordOpen"
				@submit.prevent="login">
				<label class="login__form__label" for="stipt_email">E-mail</label>
				<br>
				<input
					class="login__form__input login__form__input--email"
					type="email"
					name="stipt_email"
					v-model="email"/>
				<br>
				<label class="login__form__label" for="stipt_password">Password</label>
				<br>
				<input
					class="login__form__input login__form__input--password"
					type="password"
					name="stipt_password"
					v-model="password"/>
				<br>
				<button
					class="login__form__submit" type="submit">
					Login
				</button>
				<button
					type="button"
					@click="forgotPasswordOpen = true"
					class="login__form__forgot">
					Forgot password?
				</button>
			</form>
			<form v-else>
				<label class="login__form__label" for="stipt_email">E-mail</label>
				<input
					class="login__form__input login__form__input--email"
					type="email"
					name="stipt_email"
					v-model="forgotEmail"/>
				<button
					@click="forgotPassword(forgotEmail)"
					class="login__form__submit" type="submit">
					Send password recovery
				</button>
			</form>
		</div>
	</div>
</template>

<script>
import Alert from '@/components/Alert'
import AuthenticationService from '@/services/AuthenticationService'
export default {
	components: {
		Alert
	},
	data () {
		return {
			email: '',
			password: '',
			alert_message: '',
			alert_button: null,
			registered: true,
			forgotPasswordOpen: false,
			forgotEmail: ''
		}
	},
	computed: {
		loggedIn () {
			return this.$store.state.authentication.loggedIn
		}
	},
	methods: {
		async login () {
			try {
				const response = await AuthenticationService.login({
					email: this.email,
					password: this.password
				})
				if (response.error) {
					this.alert_message = response.error.message
					this.alert_button = response.error.button
					return
				}
				// Save the login info in the store
				this.$store.dispatch('login', response)
				// Redirect to the homepage
				this.$router.push({ name: 'plannings' })
			} catch (err) {
				this.alert_message = err.message
			}
		},
		async forgotPassword (email) {
			await AuthenticationService.forgotPassword(email)
		},
		async sendVerification () {
			await AuthenticationService.sendVerification(this.email)
		}
	},
	mounted () {
	},
	async created () {
		// Check if the person is logging in through a verification token
		if (this.$route.name === 'verify') {
			const success = await AuthenticationService.verifyAccount(this.$route.params.token)
			if (success) this.alert_message = 'Thanks for verifying your account! You can now sign in.'
		}
		if (this.$route.query.registered) {
			this.alert_message = 'Thanks for signing up! Please find our verification mail in your inbox.'
		}
	}
}
</script>

<style lang="scss" scoped>
@import '@/styles/views/_login.scss'
</style>
